import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { BillPayService } from '../../services/bill-pay.service';

export const billPayGuard: CanActivateFn = () => {
  const billPayService = inject(BillPayService);
  const router = inject(Router);

  return billPayService.getDetails().pipe(
    map((details) => (details.hasBillPay ? true : router.createUrlTree(['/login']))),
    catchError(() => of(router.createUrlTree(['/login'])))
  );
};
